import { ACTION_TYPES } from '../../constants/protocol';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import {
  handleUnSelectIndividualMachine,
  selectEssSwitch,
} from '../store/slices/essSwitchSlice';
import {
  handleDisplaySelectBoxWithAction,
  handleResetAllSelect,
} from '../store/slices/masterControlSelectSlice';
import {
  handleApplyCommand,
  handleCommandInfo,
  handleCommandDate,
  handleControlResetInit,
  handleCreateCommand,
  handleResetCommandNumber,
  selectMCCommand,
  handleResetCreateNewCommand,
} from '../store/slices/mCCommandSlice';
import { handleUnselectAllSystem, selectMC } from '../store/slices/mCSlice';
import { handleResetAll } from '../store/slices/selectedMachinesSlice';
import {
  selectTesSwitch,
  tesHandleUnSelectIndividualMachine,
} from '../store/slices/tesSwitchSlice';
import {
  selectTgsSwitch,
  tgsHandleUnSelectIndividualMachine,
} from '../store/slices/tgsSwitchSlice';
import { flexDirectionColumn, layerADark } from '../styles/commonStyles';
import TitleContainer from '../TitleContainer';
import MasterControlContents from './MasterControlContents';
import ContainerSelectSystem from './selectSystemAndAddCommand/ContainerSelectSystem';
import SelectCreateNewCommandMessage from './userMessages/SelectCreateNewCommandMessage';
import MasterControlProvider from './MaterControlContext';
import { getAuditTrailService } from '../../services';
import { selectUserInfo } from '../store/slices/userSlice';
import { selectUnits } from '../store/slices/settings/unitsSlice';
import moment from 'moment';
import SelectSystemMessage from './userMessages/SelectSystemMessage';
import { useCreateNewCommandPrompt } from './useCreateNewCommandPrompt';

const MasterControlMain = () => {
  const dispatch = useDispatch();

  const { flatEssSwitch } = useSelector(selectEssSwitch);
  const { flatTesSwitch } = useSelector(selectTesSwitch);
  const { flatTgsSwitch } = useSelector(selectTgsSwitch);
  const { user } = useSelector(selectUserInfo);
  const { isF } = useSelector(selectUnits);

  const mCState = useSelector(selectMC);

  const essSelectSystem = mCState.selectSystem.ess;
  const tgsSelectSystem = mCState.selectSystem.tgs;
  const tesSelectSystem = mCState.selectSystem.tes;
  const hpSelectSystem = mCState.selectSystem.hp;

  const mCCommandState = useSelector(selectMCCommand);
  const { commandDate, isNewCommandCreated } = mCCommandState;
  const [toggleButtonColor, setToggleButtonColor] = useState(false);

  const {
    isPromptVisible: messageBoxOfCreateNewCommand,
    raisePrompt: handleCreateNewCommandMessageBox,
    dismissPrompt: dismissCreateNewCommandMessageBox,
  } = useCreateNewCommandPrompt(isNewCommandCreated);
  const [commandConfirmed, setCommandConfirmed] = useState(false);

  const controllersInitialState = [false, false, false, false, false];
  const [controllersStatus, setControllersStatus] = useState(
    controllersInitialState
  );

  const [isSystemSelectedMessage, setIsSystemSelectedMessage] = useState(false);

  useEffect(() => {
    // The history text is formatted in the unit current at fetch time; after a
    // quick °F/°C switch, drop the older response so it can't land last.
    let current = true;
    getAuditTrailService({
      actionType: ACTION_TYPES.GLOBAL_MASTER_CONTROL,
    }).then((res) => {
      if (!current) return;
      dispatch(
        handleCommandInfo({
          data: res,
          user,
          isF,
          flatEssSwitch,
          flatTgsSwitch,
          flatTesSwitch,
        })
      );
    });
    return () => {
      current = false;
    };
  }, [isF]);

  useEffect(() => {
    dispatch(handleUnselectAllSystem());
    dispatch(handleResetAll());
    dispatch(handleResetAllSelect());
    dispatch(handleResetCreateNewCommand());
  }, []);

  useEffect(() => {
    if (commandDate) {
      let difference = moment().diff(commandDate, 'days');
      if (difference) {
        dispatch(handleResetCommandNumber());
      }
    } else {
      dispatch(handleCommandDate(moment().format('DDMMYY')));
    }
  }, [moment().format('DDMMYY')]);

  useEffect(() => {
    if (isNewCommandCreated) {
      if (essSelectSystem) {
        dispatch(handleDisplaySelectBoxWithAction(false));
        setToggleButtonColor(0);
        dispatch(handleControlResetInit(false));
      } else if (tgsSelectSystem) {
        dispatch(handleDisplaySelectBoxWithAction(false));
        setToggleButtonColor(1);
        dispatch(handleControlResetInit(false));
      } else if (tesSelectSystem) {
        dispatch(handleDisplaySelectBoxWithAction(false));
        setToggleButtonColor(2);
        dispatch(handleControlResetInit(false));
      } else if (hpSelectSystem) {
        dispatch(handleDisplaySelectBoxWithAction(false));
        setToggleButtonColor(3);
        dispatch(handleControlResetInit(false));
      }
    }

    return () => {
      dispatch(handleApplyCommand(false));
      setToggleButtonColor(false);
    };
  }, [essSelectSystem, tgsSelectSystem, tesSelectSystem, hpSelectSystem]);

  const handleCreateNewCommand = (e) => {
    e.stopPropagation();
    dispatch(handleCreateCommand());
    dispatch(handleResetAllSelect());
    dispatch(handleResetAll());
    dispatch(handleApplyCommand(false));
    dispatch(handleUnselectAllSystem());
    dispatch(handleControlResetInit(false));
    dismissCreateNewCommandMessageBox();

    if (essSelectSystem) {
      return Object.keys(flatEssSwitch).forEach((location) =>
        Object.keys(flatEssSwitch[location]).forEach((machine) => {
          dispatch(handleUnSelectIndividualMachine({ location, machine }));
        })
      );
    } else if (tgsSelectSystem) {
      return Object.keys(flatTgsSwitch).forEach((location) =>
        Object.keys(flatTgsSwitch[location]).forEach((machine) => {
          dispatch(tgsHandleUnSelectIndividualMachine({ location, machine }));
        })
      );
    } else if (tesSelectSystem) {
      return Object.keys(flatTesSwitch).forEach((location) =>
        Object.keys(flatTesSwitch[location]).forEach((machine) => {
          dispatch(tesHandleUnSelectIndividualMachine({ location, machine }));
        })
      );
    } else return;
  };

  const handleMessageBoxOfSelectSystem = () => {
    !essSelectSystem &&
      !tesSelectSystem &&
      !tgsSelectSystem &&
      !hpSelectSystem &&
      isNewCommandCreated &&
      setIsSystemSelectedMessage(true);
  };

  const selectSystemMessage = [
    'you must first select the desired system',
    'ess-electric switch system',
    'tgs-typhoon gas system',
    'tes-typhoon electric system',
    'hp-heated platform',
  ];

  return (
    <Wrapper>
      <MasterControlProvider>
        <TitleContainer title='master control' />
        <ContentsWrapper>
          <ContainerSelectSystem
            toggleButtonColor={toggleButtonColor}
            handleCreateNewCommand={handleCreateNewCommand}
            handleCreateNewCommandMessageBox={handleCreateNewCommandMessageBox}
            setIsSystemSelectedMessage={setIsSystemSelectedMessage}
          />

          {messageBoxOfCreateNewCommand && (
            <SelectCreateNewCommandMessage
              title={'master control commands'}
              message={'please select "create new command"'}
              onClose={dismissCreateNewCommandMessageBox}
            />
          )}

          {isSystemSelectedMessage && isNewCommandCreated && (
            <SelectSystemMessage
              title={'master control commands'}
              subtitle={'select system'}
              messages={selectSystemMessage}
              onClose={() => setIsSystemSelectedMessage(false)}
            />
          )}

          <MasterControlContents
            controllersStatus={controllersStatus}
            setControllersStatus={setControllersStatus}
            setCommandConfirmed={setCommandConfirmed}
            handleCreateNewCommand={handleCreateNewCommand}
            handleCreateNewCommandMessageBox={handleCreateNewCommandMessageBox}
            commandConfirmed={commandConfirmed}
            isSystemSelectedMessage={isSystemSelectedMessage}
            handleMessageBoxOfSelectSystem={handleMessageBoxOfSelectSystem}
            messageBoxOfCreateNewCommand={isNewCommandCreated}
          />
        </ContentsWrapper>
      </MasterControlProvider>
    </Wrapper>
  );
};

export default MasterControlMain;

const Wrapper = styled.div`
  height: 674px;
  width: 1216px;

  ${flexDirectionColumn}
  position: relative;
`;

const ContentsWrapper = styled.div`
  width: 1216px;
  height: 632px;
  border-radius: 26px 16px 16px 16px;

  ${layerADark}

  display: flex;
  justify-content: space-between;

  padding: 10rem;
`;
